import { render, staticRenderFns } from "./CalendarTripDetails.vue?vue&type=template&id=a6010584&scoped=true&"
import script from "./CalendarTripDetails.vue?vue&type=script&lang=js&"
export * from "./CalendarTripDetails.vue?vue&type=script&lang=js&"
import style0 from "./CalendarTripDetails.vue?vue&type=style&index=0&id=a6010584&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6010584",
  null
  
)

export default component.exports